import { callApi } from "../../libs"

const createPaymentFromPreBookingId = async (preBookingId) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/pre-bookings/convert/booking`
        const method = 'post'
        const body = {
            preBookingId
        }
        try {
            const response = await callApi(method, url, body, null)
            // console.log(response)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default createPaymentFromPreBookingId